import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle, ArrowRight } from "lucide-react";

const WA_CHANNEL = "https://whatsapp.com/channel/0029Vb6uEOf1yT2DtfoL0a1b";

export default function GoldRatesWidget({ showCTA = true }) {
    const { rates } = useSettings();
    if (!rates.gold_24k) return null;
    const items = [
        { label: "24K Gold", short: "24K", value: rates.gold_24k, unit: "g" },
        { label: "22K Gold", short: "22K", value: rates.gold_22k, unit: "g" },
        { label: "20K Gold", short: "20K", value: rates.gold_20k, unit: "g" },
        { label: "18K Gold", short: "18K", value: rates.gold_18k, unit: "g" },
        { label: "Silver", short: "Ag", value: rates.silver, unit: "kg" },
    ];
    const fmt = (n) => "₹" + Math.round(Number(n)).toLocaleString("en-IN");
    return (
        <div data-testid="gold-rates-widget">
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                {items.map((it) => (
                    <div key={it.label} className="relative bg-[color:var(--pearl)] border border-[color:var(--soft-border)] p-5 text-center overflow-hidden group">
                        <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[color:var(--champagne)] to-transparent opacity-60" />
                        <div className="font-accent text-[10px] tracking-[0.32em] text-[color:var(--champagne)] mb-2">{it.short}</div>
                        <div className="eyebrow text-[color:var(--muted-brown)] mb-1.5">{it.label}</div>
                        <div className="font-serif-luxe text-2xl md:text-[1.65rem] leading-tight text-[color:var(--charcoal)]">{fmt(it.value)}</div>
                        <div className="text-[10px] tracking-widest text-[color:var(--muted-brown)] mt-0.5">PER GRAM</div>
                        {it.unit === "g" && (
                            <div className="mt-2 pt-2 border-t border-[color:var(--soft-border)]">
                                <div className="font-serif-luxe text-base text-[color:var(--charcoal)]">{fmt(it.value * 10)}</div>
                                <div className="text-[10px] tracking-widest text-[color:var(--muted-brown)]">PER 10 GRAM</div>
                            </div>
                        )}
                        {it.unit === "kg" && (
                            <div className="mt-2 pt-2 border-t border-[color:var(--soft-border)]">
                                <div className="font-serif-luxe text-base text-[color:var(--charcoal)]">{fmt(it.value * 1000)}</div>
                                <div className="text-[10px] tracking-widest text-[color:var(--muted-brown)]">PER KG</div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {showCTA && (
                <div className="mt-6 flex flex-wrap items-center justify-between gap-3">
                    <a href={WA_CHANNEL} target="_blank" rel="noreferrer" className="btn-whatsapp" data-testid="rates-wa-channel">
                        <MessageCircle size={16} /> Follow Live Rates on WhatsApp
                    </a>
                    <Link to="/gold-rates" className="text-[11px] tracking-[0.22em] font-semibold link-underline text-[color:var(--charcoal)]" data-testid="view-all-rates">
                        VIEW ALL RATES <ArrowRight size={12} className="inline-block ml-1" />
                    </Link>
                </div>
            )}
        </div>
    );
}
